/* unplugin-vue-components disabled */import { render } from "./KilaKilaUploader.vue?vue&type=template&id=15e8850d&scoped=true"
import script from "./KilaKilaUploader.vue?vue&type=script&lang=js"
export * from "./KilaKilaUploader.vue?vue&type=script&lang=js"

import "./KilaKilaUploader.vue?vue&type=style&index=0&id=15e8850d&lang=less&scoped=true"

import exportComponent from "/Users/zhaoxu/Documents/development.localized/public.localized/github/KilaKila-Blog/kilakila-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15e8850d"]])

export default __exports__